import React from 'react';

const Reporte = ({couleur = "#F82121"}) => {
    return (
        <div style={{position: 'relative', width: '18px', height: '18px'}} className={"iconeReporte"}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
                 style={{position: 'absolute', top: '0', left: '0'}}>
                <circle cx="9" cy="9" r="9" fill={couleur}/>
            </svg>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"
                 style={{position: 'absolute', top: '2px', left: '2px'}}>
                <path d="M3.75391 5.4668L1.6998 5.6814L0.798678 3.88676" stroke="white"/>
                <path
                    d="M1.91591 5.37767C2.81116 2.55732 5.82325 0.996705 8.64361 1.89195C11.464 2.7872 13.0246 5.7993 12.1293 8.61965C11.2341 11.44 8.22198 13.0006 5.40163 12.1054C3.224 11.4141 2.26384 9.84338 1.91591 8.35033"
                    stroke="white"/>
                <path d="M6.90332 3.74609L6.90332 7.2763" stroke="white"/>
                <path d="M8.59863 8.73047L6.73748 6.86702" stroke="white"/>
            </svg>
        </div>
    );
};

export default Reporte;
